import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogStartOperationComponent } from './dialogStartOperation.component';
import { SharedModule } from '@/shared/shared.module';

@NgModule({
  declarations: [DialogStartOperationComponent],
  imports: [CommonModule, SharedModule],
})
export class DialogStartOperationModule {

}
